// extracted by mini-css-extract-plugin
module.exports = {"formComponent":"ResetForm_formComponent__3YHlV","form":"ResetForm_form__2JTlB","input":"ResetForm_input__2AaNb"};